import { ModalContainer } from "@kyan/ui";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { routes } from "#/config/routes";
import { useEquityModalTab } from "#/store/app/equityModal/equityModalTab";
import { useShowBridgeHistory } from "#/store/app/equityModal/showBridgeHistory";
import { useShowEquityModal } from "#/store/app/equityModal/showEquityModal";

import { EquityModalContent } from "./components/EquityModalContent/EquityModalContent";
import { TxPendingModalContent } from "./components/TxPendingModalContent/TxPendingModalContent";
import { TxSuccessModalContent } from "./components/TxSuccessModalContent/TxSuccessModalContent";
import { useTxState } from "./EquityModal.hook";
import { type TxModalVariant, TxStatus } from "./EquityModal.types";

export const EquityModal: React.FC = () => {
  const router = useRouter();
  const { showEquityModal, setShowEquityModal } = useShowEquityModal();

  const { txState, setTxState } = useTxState();
  const { equityModalTab } = useEquityModalTab();
  const { setShowBridgeHistory } = useShowBridgeHistory();

  useEffect(() => {
    if (showEquityModal) {
      return;
    }

    setTxState({
      status: TxStatus.IDLE,
    });
    setTimeout(() => setShowBridgeHistory(false), 500);
  }, [setTxState, showEquityModal, setShowBridgeHistory]);

  return (
    <ModalContainer open={showEquityModal} onOpenChange={setShowEquityModal}>
      {[TxStatus.IDLE, TxStatus.ERROR].includes(txState.status) && (
        <EquityModalContent key="equity-modal-content" />
      )}

      {txState.status === TxStatus.PENDING && (
        <TxPendingModalContent
          progress={10}
          amount={txState.amount}
          key="equity-modal-pending"
          variant={equityModalTab as TxModalVariant}
        />
      )}
      {txState.status === TxStatus.SUCCESS && (
        <TxSuccessModalContent
          txState={txState}
          key="equity-modal-success"
          variant={equityModalTab as TxModalVariant}
          onTxHistoryClick={() => {
            setShowEquityModal(false);
          }}
          onTradeClick={() => {
            setShowEquityModal(false);
            router.push(routes.options());
          }}
        />
      )}
    </ModalContainer>
  );
};
